export default __webpack_public_path__ + "static/media/soup.060c6d44.png";